import React from 'react';
import { FieldType } from 'types/FieldTypes';
import FormModal from 'components/modals/FormModal';
import { KNOWLEDGE_BASE_GROUP_ICONS, groupIconKey } from '../../knowledge_base/KnowledgeBaseTypes';

// The form to add or edit a knowledge base group
const KnowledgeBaseGroupForm: React.FC<{ viewKey?: string }> = ({ viewKey }) => {

    const apiObject = 'knowledge_base_group_as_superuser';

    // Plug in the fields and their properties
    const fields: FieldType[] = [
        {
            name: 'name',
            label: 'knowledge_base.group.name_label',
            type: 'text',
            placeholder: 'knowledge_base.group.name_placeholder',
        },
        {
            name: 'description',
            label: 'knowledge_base.group.description_label',
            type: 'textarea',
            placeholder: 'knowledge_base.group.description_placeholder',
            rows: 3,
        },
        {
            name: 'icon',
            label: 'knowledge_base.group.icon_label',
            type: 'tabs',
            showIconOnly: true,
            defaultValue: 'book-open',
            customClass: 'kb-icon-option',
            options: KNOWLEDGE_BASE_GROUP_ICONS.map(icon => ({ value: icon, name: icon, icon: groupIconKey(icon) })),
        },
    ];

    return (
        <FormModal
            viewKey={viewKey}
            apiObject={apiObject}
            fields={fields}
        />
    );
};

export default KnowledgeBaseGroupForm;
